import styledComponents from "styled-components"
import mainTheme from "../../../../muiTheme"

const CircleContent = ({text=''}) => {
    return (
        <CircleContentStyle>
            {text}
        </CircleContentStyle>
    )
}

const CircleContentStyle = styledComponents.div`
    width: 30px;
    height: 30px;
    border: 1px solid ${mainTheme.palette.primary.dark};
    border-radius: 1000px;
    border-style: dotted;
    border-width: 2px;
    display:flex;
    justify-content: center;
    align-items: center;
    color: ${mainTheme.palette.primary.dark};
    font-weight: bold;
`

export default CircleContent
